import { Component, OnInit } from '@angular/core';
import { DynamicDialogRef } from "primeng/dynamicdialog";

@Component({
  selector: 'app-delete-group-dialog',
  templateUrl: './delete-group-dialog.component.html',
  styleUrls: ['./delete-group-dialog.component.scss']
})
export class DeleteGroupDialogComponent implements OnInit {

  //#region Fields
  //#endregion

  //#region Constructor
  constructor(
    private ref: DynamicDialogRef
  ) {
  }

  public ngOnInit(): void {
  }
  //#endregion

  //#region Public Methods
  public deleteGroup(): void {
    this.ref.close(true);
  }

  public cancel(): void {
    this.ref.close(false);
  }
  //#endregion
}
